import { ISMBase } from '../ism-base';
export class Oracle extends ISMBase {
    constructor() {
        super(...arguments);
        /**
         * provider : Oracle
         */
        this.identityServiceProvider = 'oracle';
        this.priorityOrder = 2;
    }
    /**
     * If Oracle data is available within the given timeframe, set targeting on ad requests.
     * We send npi Hash(amid), truncated hash(nid), spr(profession), ssp(specialty) & oraclesegments to GAM.
     */
    setIdentityServiceProviderTargeting(identityServiceProviderData) {
        let providerData = identityServiceProviderData || this.controller.getServiceData(this.identityServiceProvider);
        const data = providerData && providerData.value;
        const npiNumber = data && data['NPI'];
        let existingData = this.controller.gamTargetingData.findIndex((value) => {
            return value.priorityOrder === this.priorityOrder;
        });
        let targetingData = {};
        if (npiNumber) {
            targetingData['npi'] = npiNumber;
        }
        if (data && data['Profession']) {
            targetingData['spr'] = data['Profession'];
        }
        if (data && data['Specialty']) {
            targetingData['ssp'] = data['Specialty'];
        }
        if (data && data['Segments'] && data['Segments'].length) {
            targetingData['oracleSegments'] = data['Segments'];
        }
        if (existingData > -1) {
            Object.keys(targetingData).length && Object.assign(this.controller.gamTargetingData[existingData].targetingData, targetingData);
        }
        else {
            let providerTargetingData = { 'priorityOrder': this.priorityOrder, 'targetingData': targetingData };
            this.controller.gamTargetingData.push(providerTargetingData);
        }
    }
    /**
     * Adretarget/Ad refresh only when the new spr, ssp, npi or segments returned by Oracly Unity is different from the one returned previously by Oracle.
     */
    hasTargetingChanged() {
        let newData = this.controller.getServiceData(this.identityServiceProvider); // New data stored in ism.dataStack
        let LSDataArr = this.controller.getISMDataFromLocalStorage(this.identityServiceProvider); // data stored in LocalStorage
        const LSData = LSDataArr.length && LSDataArr[0];
        let newSegments = newData && newData.value && newData.value['Segments'];
        let LSSegments = LSData && LSData.value['Segments'];
        let newProfession = newData && newData.value && newData.value['Profession'];
        let LSProfession = LSData && LSData.value['Profession'];
        let newSpecialty = newData && newData.value && newData.value['Specialty'];
        let LSSpecialty = LSData && LSData.value['Specialty'];
        let newNPI = newData && newData.value && newData.value['NPI'];
        let LSNPI = LSData && LSData.value['NPI'];
        let segmentsEqual = false;
        let oracleData = {};
        if (newSegments && LSSegments && newSegments.length === LSSegments.length) { /* only if length is equal compare its content */
            newSegments.length && newSegments.sort(function (a, b) { return a.localeCompare(b); }); //sort it before comparing.localeCompare is used as this array contains string with special characters.
            LSSegments.length && LSSegments.sort(function (a, b) { return a.localeCompare(b); }); // sore it before comparing.localeCompare is used as this array contains string with special characters.
            segmentsEqual = JSON.stringify(newSegments) === JSON.stringify(LSSegments);
            oracleData['segmentsEqual'] = 'Segments length is equal but the content is different';
        }
        if (!segmentsEqual) { /* log data to new relic if segments are not equal */
            oracleData = Object.assign(oracleData, this.getDefaultNewRelicInfo());
            oracleData['eventType'] = 'ISM Retarget change in Provider Data';
            oracleData['LSSegments'] = LSSegments && LSSegments.length;
            oracleData['NewSegments'] = newSegments && newSegments.length;
            window.hmLog && window.hmLog.sendToNewRelic(oracleData, true);
        }
        if (segmentsEqual
            && newProfession === LSProfession
            && newSpecialty === LSSpecialty
            && newNPI === LSNPI) {
            return true;
        }
        return false;
    }
}
